angular.module('app.formalizacao').factory('ccbReprocessamentoCopiaFactory', function ($http) {
    var baseUrl = 'api/CopiaDocumentosCCB';

    return {
        reprocessarPropostas: function (codigosPropostas, callback) {
            var request = {
                parms: [
                    { name: 'CodigosPropostas', value: codigosPropostas }
                ],
                search: ''
            };
            $http.post(appConfig.serviceBase + baseUrl + '/ReprocessarPropostas', request)
                .then(function (response) {
                    callback.success(response.data);
                }, function (error) {
                    callback.error(error);
                });
        }
    };
});
